/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import sanitizeIds from '../Utilities/id/sanitizeIds.js';
import { useTranslation } from '../Utilities/i18n/i18n.js';

var ErrorDarkBlue = function ErrorDarkBlue(_ref) {
  var id = _ref.id,
    ariaLabelProp = _ref.ariaLabel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var ariaLabel = ariaLabelProp || t('Error state icon');
  var uniqueId = id || Math.floor(1000 + Math.random() * 9000);
  var gradientIds = sanitizeIds(['error--dark-blue-2', 'error--dark-blue-3', 'error--dark-blue-4', 'error--dark-blue-5', 'error--dark-blue-1', 'error--dark-blue-6', 'error--dark-blue-7', 'error--dark-blue-8'], uniqueId);
  return /*#__PURE__*/React.createElement("svg", {
    "aria-label": ariaLabel,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 200"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-2'],
    x1: "66.98",
    x2: "66.98",
    y1: "-4.33",
    y2: "190.03",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#f6f2ff",
    stopOpacity: "0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".47",
    stopColor: "#bdccfe",
    stopOpacity: ".47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".81",
    stopColor: "#99b4fe",
    stopOpacity: ".81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8babfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#8cacfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-3'],
    x1: "116.59",
    x2: "35.2",
    y1: "1816.57",
    y2: "1865.25",
    gradientTransform: "matrix(1 0 0 -1 0 1977.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".01",
    stopColor: "#545a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3a3b46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-4'],
    x1: "67.19",
    x2: "134",
    y1: "1824.3",
    y2: "1824.3",
    gradientTransform: "matrix(1 0 0 -1 0 1977.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#313437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#434251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-5'],
    x2: "67.24",
    y1: "1824.3",
    y2: "1824.3",
    gradientTransform: "matrix(1 0 0 -1 0 1977.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#28292d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#3c3d40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-1'],
    x1: "48.34",
    x2: "79.9",
    y1: "119.98",
    y2: "88.42",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#324280"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#908dd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-6'],
    x1: "68.13",
    x2: "68.13",
    y1: "134.08",
    y2: "87.9",
    xlinkHref: "#".concat(gradientIds['error--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-7'],
    x1: "48.07",
    x2: "75.27",
    y1: "119.15",
    y2: "91.95",
    xlinkHref: "#".concat(gradientIds['error--dark-blue-1'])
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: gradientIds['error--dark-blue-8'],
    x1: "61.43",
    x2: "61.43",
    y1: "1889.44",
    y2: "1857.95",
    gradientTransform: "matrix(1 0 0 -1 0 1977.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0",
    stopColor: "#ccd5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#a0b0e7"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-2'], ")"),
    d: "M66.76 92.24L134 131.17V-10H0v141.17z",
    opacity: ".1",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-3'], ")"),
    d: "M0 131.07l66.81-38.93L134 131.07 67.24 170z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-4'], ")"),
    d: "M134 131.07v4.9L67.19 174.9V170z",
    opacity: ".7",
    style: {
      isolation: 'isolate'
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-5'], ")"),
    d: "M67.24 170v4.9L0 136v-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    fillOpacity: ".3",
    d: "M67.19 174.9l-54.2-31.4L0 151.07 67.19 190l66.77-38.93-12.99-7.52-53.78 31.35z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-1'], ")"),
    d: "M67.74 78c-5.74-3.36-11-3.65-14.74-1.45l-5.15 3c3.77-2.21 9-1.91 14.78 1.42 11.48 6.61 20.76 22.56 20.7 35.66 0 6.49-2.34 11.07-6 13.27l5.15-3c3.71-2.15 6-6.73 6-13.28.02-13.08-9.25-29.09-20.74-35.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-1'], ")"),
    d: "M62.6 81c11.48 6.61 20.76 22.56 20.7 35.66S74 135 62.48 128.45 41.72 105.9 41.78 92.8 51.11 74.35 62.6 81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-1'], ")"),
    d: "M61.46 118.82a5.63 5.63 0 01-2.07-1.93 4.47 4.47 0 01-.62-2.3v-.75c0-.81.19-1.31.62-1.56s1.13-.12 2.07.44a4.91 4.91 0 012 1.93 5 5 0 01.63 2.31v.74c0 .81-.19 1.31-.63 1.56s-1.06.06-2-.44zm-.88-11.52l-1.37-11.91v-7.54l4.51 2.62V98l-1.32 10.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-6'], ")"),
    d: "M67.74 78c-5.74-3.36-11-3.65-14.74-1.45l-5.15 3c3.77-2.21 9-1.91 14.78 1.42 11.48 6.61 20.76 22.56 20.7 35.66 0 6.49-2.34 11.07-6 13.27l5.15-3c3.71-2.15 6-6.73 6-13.28.02-13.08-9.25-29.09-20.74-35.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-7'], ")"),
    d: "M62.6 81c11.48 6.61 20.76 22.56 20.7 35.66S74 135 62.48 128.45 41.72 105.9 41.78 92.8 51.11 74.35 62.6 81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(gradientIds['error--dark-blue-8'], ")"),
    d: "M61.46 118.82a5.63 5.63 0 01-2.07-1.93 4.47 4.47 0 01-.62-2.3v-.75c0-.81.19-1.31.62-1.56s1.13-.12 2.07.44a4.91 4.91 0 012 1.93 5 5 0 01.63 2.31v.74c0 .81-.19 1.31-.63 1.56s-1.06.06-2-.44zm-.88-11.52l-1.37-11.91v-7.54l4.51 2.62V98l-1.32 10.35z"
  }));
};
ErrorDarkBlue.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string
};
var ErrorDarkBlue$1 = ErrorDarkBlue;

export { ErrorDarkBlue$1 as default };
